import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  TextField,
  IconButton,
  Typography,
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { toast } from "react-toastify";
import {MessageAnnotationsRepository} from "../../../../repositories/MessageAnnotationRepository";

export const ExportDialog = ({ open, onClose }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const params = {};

      if (startDate) {
        params.startDate = startDate;
      }
      if (endDate) {
        params.endDate = endDate;
      }

      const response = await MessageAnnotationsRepository.export(params);

      // Create blob and download file
      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      // Generate filename with date range if provided
      let filename = 'message-annotations';
      if (startDate || endDate) {
        filename += '_';
        if (startDate) filename += `from-${startDate.split('T')[0]}`;
        if (endDate) filename += `${startDate ? '_' : ''}to-${endDate.split('T')[0]}`;
      }
      filename += '.csv';

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Annotations exported successfully");
      onClose();
    } catch (error) {
      console.error("Failed to export annotations:", error);
      toast.error("Failed to export annotations");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setStartDate("");
    setEndDate("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight={600}>
            Export Annotations
          </Typography>
          <IconButton onClick={handleClose} sx={{ borderRadius: "50% !important" }}>
            <IconX size={20} />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Select a date range to filter annotations. Leave both fields empty to export all annotations.
          </Typography>
          <TextField
            label="Start Date"
            type="datetime-local"
            size="small"
            fullWidth
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="End Date"
            type="datetime-local"
            size="small"
            fullWidth
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
          <Button onClick={handleClose} variant="ghost" sx={{ minWidth: 100 }}>
            Close
          </Button>
          <Button
            onClick={handleExport}
            variant="modal"
            disabled={loading}
            sx={{ flex: 1 }}
          >
            {loading ? "Downloading..." : "Download"}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
